import React from 'react';
import { Layout } from 'antd';
import cx from 'classnames';

import { UserRoutes } from 'components/Routes';
import Sidebar from 'components/sidebars/Sidebar';
import TopMenu from './TopMenu';
import LeftMenu from './LeftMenu';

const UserLayout = ({ user, user: { permissions }, getCompanyInfo, leftMenuPinned }) => (
    <Layout className="main">
        <TopMenu user={user} getCompanyInfo={getCompanyInfo} />
        <Layout className="wrap-sidebar-content ant-layout-has-sider">
            <LeftMenu user={user} />
            <Layout className={cx("wrap-content content-scroll", {
                    'left-menu-is-pinned': leftMenuPinned,
                    'left-menu-is-unpinned': !leftMenuPinned,
                })}>
                { permissions && <UserRoutes permissions={permissions} user={user} /> }
            </Layout>
            <Sidebar />
        </Layout>
    </Layout>
);

export default UserLayout;
